import EmailInput from "../../../../utils/form/EmailInput";

const PatientEmailInput = props =>  <EmailInput fullWidth {...props} />;

export default PatientEmailInput;